import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PATHS } from '../../../../models/bary-paths.model';
import { Transporter } from '../../../../models/transporter.model';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-sidebar-accordion-admin',
  templateUrl: './bary-sidebar-accordion-admin.component.html',
  styleUrls: ['./bary-sidebar-accordion-admin.component.scss'],
})
export class BarySidebarAccordionAdminComponent {
  @Input() swaggerEnabled = true;
  @Input() inProduction = false;
  @Input() transporters: Transporter[] = [];

  @Output() goToEvent = new EventEmitter<string>();

  protected readonly PATHS = PATHS;
  protected readonly FAS = FaDirectiveEnum.FAS;

  public handleGoTo(path: string): void {
    this.goToEvent.emit(path);
  }

  public trackById(index: number, item: Transporter): any {
    return item.id!;
  }
}
